export enum MenuNames {
    ItemsMenu = 'items',
    CraftingMenu = 'crafting',
    CharacterMenu = 'character',
    CompanionMenu = 'companion',
    FamiliarMenu = 'familiar',
    SpellsMenu = 'spells',
    SpellLibraryMenu = 'spelllibrary',
    ConditionsMenu = 'conditions',
    DiceMenu = 'dice',
}
